import "./scss/init.scss";

import Vue from 'vue';
import Vuelidate from 'vuelidate';
import Paginate from 'vuejs-paginate'
import VueSignaturePad from 'vue-signature-pad';
import router from './router';
import store from './store';
// import registerVueDirectives from "./directives";
import App from './App';
import VueScrollbar from 'vue2-scrollbar';
import VueScreen from 'vue-screen';
import VueMask from 'v-mask';
import { declineWord } from "./utils";

Vue.use(Vuelidate);
Vue.use(VueSignaturePad);
Vue.use(VueScrollbar);
Vue.use(VueScreen);
Vue.use(VueMask);
Vue.component('paginate', Paginate);

// registerVueDirectives();

Vue.config.productionTip = false;

const files = require.context('./components/', true, /\.vue$/i);
files.keys().map(key =>
  Vue.component(
    key
      .split('/')
      .pop()
      .split('.')[0],
    files(key).default
  )
);

Vue.filter('dateFilter', function (val) {
  val = val.split('-');
  return `${val[2]}-${val[1]}-${val[0]}`
});

Vue.filter('remainingDays', function (date) {
  if (!date) {
    return null
  }

  const diff = new Date(date) - new Date()
  if (diff < 0) {
    return null
  }

  const days = Math.ceil(diff / 1000 / 60 / 60 / 24)

  return `${days} ${declineWord(days, ['день', 'дня', 'дней'])}`
});

window.vm = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');

const appHeight = () => {
  const doc = document.documentElement;
  doc.style.setProperty('--app-height', `${window.innerHeight}px`);
};
window.addEventListener('resize', appHeight);
appHeight();
